// routes/components/OptionalAuthRoute.tsx
/**
 * OptionalAuthRoute - Routes accessible with or without auth, passes user if available
 */

import { ReactElement, cloneElement, isValidElement } from 'react';
import { useAuth } from '../../context/AuthContext';
import { PageLoading } from '../../components/common/Loading';
import type { OptionalAuthRouteProps } from '../types';

export function OptionalAuthRoute({ children }: OptionalAuthRouteProps): ReactElement {
  const { user, loading } = useAuth();

  if (loading) {
    return <PageLoading />;
  }

  // Pass user prop if available, otherwise pass null
  if (isValidElement(children)) {
    return cloneElement(children, { user: user || null } as { user: typeof user | null });
  }

  return <>{children}</>;
}

export default OptionalAuthRoute;
